module.exports = __webpack_public_path__ + "img/ball_3_black.34042779.png";